import { Checkbox } from 'design-system-web';

/**
 * @deprecated use 'Checkbox' exported from `design-system-web` instead.
 */
export default Checkbox;
